import React from "react";

import { Container } from "../../components";

import Base from "./Base";

const propTypes = {};

const BaseMDX = ({ children, ...other }) => (
  <Base {...other}>
    <Container>{children}</Container>
  </Base>
);

BaseMDX.propTypes = propTypes;
BaseMDX.displayName = "BaseMDX";

export default BaseMDX;
